<div>
    <h1 class="title">Migration sniper list</h1>
    <div class="toolbar">
        <div [formGroup]="filterForm" class="toolbar-item">
            <div class="filters-item">
                <label for="dex" class="filters-item-label">Exchanges</label>
                <nz-select
                    formControlName="dex"
                    class="select"
                    nzMode="multiple"
                    [nzPlaceHolder]="'All'"
                    [nzMaxTagCount]="1"
                    [nzShowSearch]="false"
                    nzAllowClear
                    id="dex"
                >
                    @for (exchange of DEX_VALUES | keyvalue; track exchange) {
                        <nz-option
                            [nzLabel]="
                                exchange?.value?.dex
                                    ? (exchange.value?.dex || '') +
                                      ' (' +
                                      (exchange.value?.network || '') +
                                      ')'
                                    : exchange?.value?.name
                            "
                            [nzValue]="exchange.key"
                        ></nz-option>
                    }
                </nz-select>
            </div>
            <div class="filters-item">
                <label for="base-token" class="filters-item-label">Base token address</label>
                <input
                    nz-input
                    type="text"
                    id="base-token"
                    class="input"
                    formControlName="baseToken"
                    placeholder="Enter address"
                />
            </div>
            <div class="filters-item">
                <label for="tenant" class="filters-item-label">Tenant</label>
                <nz-select
                    formControlName="tenant"
                    class="select"
                    nzMode="multiple"
                    [nzPlaceHolder]="'All'"
                    [nzMaxTagCount]="1"
                    [nzShowSearch]="false"
                    nzAllowClear
                    id="tenant"
                >
                    @for (tenant of tenants$ | async; track tenant) {
                        <nz-option [nzLabel]="tenant.name" [nzValue]="tenant.id"></nz-option>
                    }
                </nz-select>
            </div>
        </div>
        <div class="toolbar-item">
            <a nz-button nzType="dashed" routerLink="/migration-sniper/add/100">
                Add migration sniper
            </a>
        </div>
    </div>
    <nz-table
        #basicTable
        [nzData]="migrationSnipers$ | async"
        nzSize="middle"
        [nzPageSize]="10"
        [nzFrontPagination]="true"
        nzShowSizeChanger
    >
        <thead>
            <tr>
                <th scope="col" [nzWidth]="'170px'">
                    <span class="header-with-hint">Info</span>
                </th>
                <th scope="col" [nzWidth]="'110px'">Base / Quote</th>
                <th
                    scope="col"
                    [nzWidth]="'90px'"
                    [nzFilters]="filtersOptions.status"
                    [nzFilterFn]="statusFilterFn"
                >
                    Status
                </th>
                <th scope="col" [nzWidth]="'90px'">Exchange</th>
                <th
                    scope="col"
                    [nzWidth]="'130px'"
                    [nzFilters]="filtersOptions.step"
                    [nzFilterFn]="stepFilterFn"
                >
                    <span class="header-with-hint">Step</span>
                </th>
                <th scope="col">
                    <span class="header-with-hint"> Creator </span>
                </th>
                <th scope="col" [nzWidth]="'120px'">
                    <div class="table-col">
                        <div>Created At</div>
                        <div class="network">Updated At</div>
                    </div>
                </th>
                <th scope="col" [nzWidth]="'38px'"></th>
            </tr>
        </thead>
        <tbody>
            @for (profile of basicTable.data; track trackById($index, profile)) {
                <tr (click)="navigateToMigrationSniper($event, profile)">
                    <td>
                        <div class="table-col">
                            <div class="item">
                                {{ profile.snipeName }}
                            </div>
                            <div>Id: {{ profile.id }}</div>
                            <div class="share-button-container network">
                                <a
                                    class="share-button"
                                    target="_blank"
                                    [href]="[
                                        '/tenants/' +
                                            profile.walletsTenantId +
                                            '/projects/' +
                                            profile.walletsProjectId +
                                            '/profiles/' +
                                            profile.walletsProfileId,
                                    ]"
                                    (click)="navigateToProfile($event)"
                                >
                                    <app-icons
                                        [name]="'share'"
                                        color="#0CBBF5"
                                        [width]="24"
                                        [height]="24"
                                    >
                                    </app-icons>
                                </a>
                                {{ profile?.walletsProfileName }}
                            </div>
                        </div>
                    </td>
                    <!--            Quote Token-->
                    <td>
                        <div class="table-col">
                            <div class="item mode">
                                {{ profile.baseToken?.symbol }} / {{ profile.quoteToken?.symbol }}
                            </div>
                        </div>
                    </td>
                    <!--            Status-->
                    <td>
                        @if (profile.status === MigrationSnipeStatusEnum.active) {
                            <app-status-label
                                [color]="'green'"
                                [title]="'Scheduled'"
                                nz-tooltip
                                [nzTooltipTitle]="
                                    profile.slotData?.unixTimestamp
                                        ? getDate(profile.slotData.unixTimestamp)
                                        : null
                                "
                            ></app-status-label>
                        }
                        @if (profile.status === MigrationSnipeStatusEnum.finished) {
                            <app-status-label
                                [color]="'grey'"
                                [title]="'Finished'"
                            ></app-status-label>
                        }
                        @if (profile.status === MigrationSnipeStatusEnum.paused) {
                            <app-status-label
                                [color]="'grey'"
                                [title]="'Paused'"
                            ></app-status-label>
                        }
                        @if (profile.status === MigrationSnipeStatusEnum.archived) {
                            <app-status-label
                                [color]="'red'"
                                [title]="'Archived'"
                            ></app-status-label>
                        }
                    </td>
                    <!--            DEX-->
                    <td>
                        <div class="table-col">
                            <span> {{ DEX_VALUES[profile.dex]?.dex || '-' }}</span>
                            <span class="network">
                                {{ DEX_VALUES[profile.dex]?.network || '-' }}</span
                            >
                        </div>
                    </td>
                    <!--            If profile corrupted or not completed-->
                    <ng-container>
                        <td>
                            <div class="table-col">
                                <span>
                                    {{ MIGRATION_SNIPER_STATUS_LABELS[profile.snipeWizardStep] }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <td>
                        {{ profile?.creator }}
                    </td>
                    <td>
                        <div class="table-col">
                            <div>{{ profile?.createdAt | date: 'dd.MM.yyyy HH:mm' }}</div>
                            <div class="network">
                                {{ profile?.updatedAt | date: 'dd.MM.yyyy HH:mm' }}
                            </div>
                        </div>
                    </td>
                    <td (click)="preventDefault($event)">
                        @if (profile.status !== MigrationSnipeStatusEnum.archived) {
                            <i
                                nz-icon
                                nzType="file-zip"
                                nzTheme="outline"
                                class="active-icon"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to archive the migration sniper?"
                                (nzOnConfirm)="archive(profile)"
                            ></i>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </nz-table>
</div>
